import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/v2/forms/TextField';
import classnames from 'classnames';

export default function InputWithLeadingIcon({
  className,
  children,
  dataTestId,
  ...props
}) {
  return (
    (<div
      data-testid={dataTestId}
      className={classnames('relative rounded-md shadow-sm', className)}>
      <div
        data-testid="div-12aaca86"
        className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        {children}
      </div>
      <TextField dataTestId="TextField-723510d7" {...props} className="pl-10" />
    </div>)
  );
}

InputWithLeadingIcon.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  children: PropTypes.node.isRequired,
};
